import { render, staticRenderFns } from "./WhatsAppSettings.vue?vue&type=template&id=da576e5c&scoped=true&"
import script from "./WhatsAppSettings.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSettings.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppSettings.vue?vue&type=style&index=0&id=da576e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da576e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
